import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CompanyService } from "src/app/services/company.service";
import { GeoService } from 'src/app/services/geo.service';
import { ActivatedRoute, Router } from "@angular/router";
import { BankService } from 'src/app/services/bank.service';
import Swal from 'sweetalert2';

import { EmailValidation, GSTValidation, PANValidation, REGNOValidation, MobileNumberValidation, UrlValidation, AlphaNumericValidation, TelephoneNumberValidation, regexPattern } from 'src/app/models/validator';
import { MiscService } from 'src/app/services/misc/misc.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { FileHandlerService } from "src/app/services/file-handler.service";
import { HttpHeaders } from "@angular/common/http";
import { UserData } from 'src/app/models/user.data-object';
import { Title } from '@angular/platform-browser';
import { NetworkService } from 'src/app/services/network.service';
import { Utilities } from 'src/app/models/utilities';

@Component({
    selector: 'app-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
})

export class EditCompanyComponent implements OnInit, AfterViewInit {
    invoiceList = [];
    totalInvoice = 0;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    isDefaultCompany = false;
    removeCheckForDefault = false;
    defaultCompanyPresent = false;
    locationDetails: any
    isEditInvoice = false;
    companyId: string;
    invoiceId: string;
    stateCode: any;
    companyForm: FormGroup;
    invoiceForm: FormGroup;
    isFormSubmitted = false;
    bankOptions: any[] = [];
    // financialYearOptions: any[] = [];
    producTypeOptions: any[] = [];
    setupTypeOptions: any[] = [{ name: 'Free Form' }, { name: 'Debit Note' }, { name: 'Credit Note' }, { name: 'Cash' }]
    companyLogoContent: any;
    signatoryLogoContent: any;

    editorConfig = {
        toolbar: 'Basic',
        height: '200px',
        width: '100%'
    };
    stateList: any[] = [];
    cityList: any[] = [];
    selectOperationTypes: string[];
    isDisabled = true;
    invoiceFormatList: [];
    billToList = ['Company', 'Service Center'];
    selectedCompanyLogoFile: File | null = null;
    companyLogoFileName = '';
    companyLogoFileURL = '';
    selectedSignatureFile: File | null = null;
    signatureFileName = '';
    signatureFileURL = '';
    showDefault = false;
    serviceCenterList: any[] = [];
    showAllocatedServiceCenter = false;

    showLogoProgressBar = false;
    showsignatrueProgressBar = false;
    logoProgress: number = 0;
    signatrueProgress: number = 0;
    useEnterKey: any;

    constructor(
        private router: Router,
        private appCoreService: AppCoreService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private companyService: CompanyService,
        private geoService: GeoService,
        private bankService: BankService,
        private miscService: MiscService,
        private ngxLoaderService: NgxUiLoaderService,
        private fileHandlerService: FileHandlerService,
        private titleService: Title,
        private networkService: NetworkService,
        private utilities: Utilities,
    ) {
        titleService.setTitle('Companies');
    }

    ngOnInit(): void {
        const userData: UserData = this.appCoreService.GetUserData();
        if (userData.accessType === 'System') {
            this.showDefault = true;
        }
        if (userData.metaInfo?.operationtype) {
            this.selectOperationTypes = userData.metaInfo?.operationtype;
        }
        this.companyForm = this.formBuilder.group({
            txtCode: new FormControl({ value: null, disabled: true }),
            txtName: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
            txtEmailId: [null, EmailValidation],
            ddlOperationType: [null, Validators.compose([Validators.required])],
            ddlServiceCenters: [[]],
            txtWebsite: [null, UrlValidation],
            txtGstNo: [null, GSTValidation],
            txtPanNo: [null, PANValidation],
            txtRegistrationNo: [null, REGNOValidation],
            txtBillingName: [null, Validators.maxLength(30)],
            ddlBillTo: ['Company', Validators.compose([Validators.required])],
            ddlInvoiceFormat: [null],
            txtStatus: [true],
            chkIsDefault: [false],
            companyLogoFileControl: [null],
            signatureFileControl: [null],

            locationdetails: this.formBuilder.group({
                ddlCountry: [null, Validators.required],
                ddlState: [null, Validators.required],
                ddlCity: [null, Validators.required],
                txtPincode: [null],
                txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
                txtAddress2: [null, Validators.maxLength(150)],
                txtArea: [null, Validators.maxLength(30)],
                txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
                txtTelephoneNo: [null, TelephoneNumberValidation],
            }),
            bankDetails: this.formBuilder.group({
                txtBankName: [],
                txtAccountNo: ['', Validators.pattern(/^\d{5,20}$/)],
                txtAccountName: [],
                txtBankAddress: [],
                txtIfscCode: [null, AlphaNumericValidation],
                txtMicr: [null, Validators.pattern(/^\d{9}$/)]
            }),

            terms: this.formBuilder.group({
                txtTerms: ''
            }),

        });

        this.companyId = this.route.snapshot.params['id'];
        this.checkPermission();
        if (this.permConfig.isEditAllowed) {
            this.bindServiceCenterList();
            this.bindCompanyDetailsById();
            this.GetAllInvoiceFormats();
            this.companyForm.get('locationdetails.ddlState').valueChanges.subscribe(newState => {
                newState && this.applyGSTValidation();
            })
        }

        const billToValue = this.companyForm.get('ddlBillTo').value;
        if (billToValue) {
            this.onBillToChange();
        }
        this.companyForm.get('ddlBillTo').valueChanges.subscribe(() => {
            this.onBillToChange();
        });
    }

    getLocation(location?: any) {
        this.stateList = location?.[0]?.state;
    }

    applyGSTValidation() {
        const docNoControl = this.companyForm.get('txtGstNo');
        const stateisocode = this.companyForm.get('locationdetails.ddlState')?.value;
        
        const taxCode = this.stateList?.find(row => row.isocode === stateisocode)?.taxcode;

        // Dynamically create the GSTIN regex pattern based on the state code
        const gstPattern = taxCode && `^(${taxCode})[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[0-9A-Z]{1}$`;

        // Now, update the regexPattern with the new dynamic pattern
        regexPattern.gstValidation = new RegExp(gstPattern);  // Update regex pattern
        docNoControl.setValidators([Validators.pattern(regexPattern.gstValidation)]);
        docNoControl.updateValueAndValidity();
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.companyForm) : null;
    }

    financialYearfun(emittedList: any[]) {
        // this.financialYearList = emittedList;
        // console.log('this.financialYearList',this.financialYearList);
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        const permission = userData.config.filter(x => x.categoryname === 'Companies');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    bindServiceCenterList() {
        try {
            this.ngxLoaderService.start();
            this.networkService.GetAllServiceCenters({ isactive: true }).subscribe((res: any) => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.serviceCenterList = res?.data.sort((a, b) => Number(a.disabled) - Number(b.disabled));
                    if (this.serviceCenterList && this.serviceCenterList.length > 0) {
                        // this.companyForm.get('ddlServiceCenters').setValue([this.serviceCenterList[0].id]);
                    }
                } else if (res && !res.success) {
                    this.ngxLoaderService.stop();
                }
            });
        } catch (e) {
            console.error(e);
            this.ngxLoaderService.stop();
        }
    }


    onBillToChange() {
        try {
            if (this.companyForm.get('ddlBillTo').value === 'Service Center') {
                // this.showAllocatedServiceCenter = true;
                this.companyForm.get('ddlServiceCenters').setValidators(Validators.required);
                this.companyForm.get('ddlServiceCenters').updateValueAndValidity();
            } else {
                // this.showAllocatedServiceCenter = false;
                this.companyForm.get('ddlServiceCenters').clearValidators();
                this.companyForm.get('ddlServiceCenters').updateValueAndValidity();
            }
        } catch (e) {
            console.error(e);
        }
    }

    onCountryChange(type?: string) {
        if (type == 'Billing') {
            // this.companyForm.get('ddlBillingState').reset();
            this.bindStatesByCountry(this.companyForm.get('ddlCountry')?.value);
        } else {
            this.cityList = [];
            this.companyForm.get('ddlCity').reset();
            this.companyForm.get('ddlState').reset();
            this.bindStatesByCountry(this.companyForm.get('ddlCountry')?.value);
        }
    }

    bindStatesByCountry(countryCode?: string) {
        try {
            if (countryCode) {
                this.geoService.GetAllStates({ countrycode: countryCode }).subscribe((res) => {
                    if (res && res.success) {
                        this.stateList = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    onStateChange() {
        const selectedValue = this.companyForm.get('ddlState')?.value;
        if (selectedValue) {
            this.bindCitiesByState(selectedValue);
        } else {
            this.companyForm.patchValue({
                ddlCity: []
            });

        }
    }

    bindCitiesByState(stateCode?: string) {
        try {
            if (stateCode) {
                this.geoService.GetAllCities({ statecode: stateCode }).subscribe((res) => {
                    if (res && res.success) {
                        this.cityList = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    getBankById() {
        this.bankService.GetAll("").subscribe((res) => {
            if (res && res.success) {
                this.bankOptions = res.data;
            }
        })
    }

    bindCompanyDetailsById() {
        this.companyService.GetById(this.companyId).subscribe((res) => {
            if (res && res.success) {
                // console.log('getById-company',res);
                this.companyForm.patchValue({
                    txtCode: res.data[0].code,
                    txtName: res.data[0].name,
                    txtEmailId: res.data[0].emailid,
                    ddlOperationType: res.data[0].operationtype,
                    ddlServiceCenters: res.data?.[0]?.servicecenters,
                    txtAddress1: res.data[0].location.address1,
                    txtAddress2: res.data[0].location.address2,
                    txtPincode: res.data[0].location.pincode,
                    ddlCountry: res.data[0].location.country,
                    ddlState: res.data[0].location.state,
                    ddlCity: res.data[0].location.city,
                    ddlBillTo: res.data[0].billto,
                    txtWebsite: res.data[0].website,
                    ddlInvoiceFormat: res.data[0].invoiceformatid,
                    txtGstNo: res.data[0].gstno,
                    txtPanNo: res.data[0].panno,
                    txtRegistrationNo: res.data[0].registrationno,
                    txtBillingName: res.data[0].billingname,
                    // ddlBillingState: res.data[0].billingstate,
                    txtStatus: res.data[0].status,
                    chkIsDefault: res.data[0].isdefault,
                    companyLogoFileControl: res.data[0].logoid,
                    signatureFileControl: res.data[0].signaturelogoid,
                });
                this.isDefaultCompany = res.data[0].isdefault;
                this.companyLogoFileName = res.data[0].logofilename;
                this.companyLogoFileURL = res.data[0].logourl;
                this.signatureFileName = res.data[0].signatoryfilename;
                this.signatureFileURL = res.data[0].signatorylogourl;
                //location
                this.locationDetails = res.data[0]?.location;
                // console.log('this.locationDetails', this.locationDetails);

                // bank details
                this.companyForm.get('bankDetails').patchValue({
                    txtBankName: res.data[0].bankdetails?.bankName,
                    txtAccountNo: res.data[0].bankdetails?.accountNo,
                    txtAccountName: res.data[0].bankdetails?.accountName,
                    txtBankAddress: res.data[0].bankdetails?.bankAddress,
                    txtIfscCode: res.data[0].bankdetails?.ifsc,
                    txtMicr: res.data[0].bankdetails?.micr,
                });

                // terms and conditions
                this.companyForm.get('terms').patchValue({
                    txtTerms: res.data[0].terms
                });
                // this.financialYearList.companyId =  this.companyId;
            }
        })
    }

    onChangeFileSelect(evt, selectedType: string) {
        try {
            if (evt) {
                if (selectedType === 'CompanyLogo') {
                    this.selectedCompanyLogoFile = evt.target.files[0];
                } else if (selectedType === 'Signature') {
                    this.selectedSignatureFile = evt.target.files[0];
                }

            }
        } catch (e) {
            console.error(e);
        }
    }

    uploadFile(selectedType: string) {
        let interval: any;
        let timeout: any;
        try {
            if (selectedType === 'CompanyLogo') {
                if (this.selectedCompanyLogoFile) {
                    this.showLogoProgressBar = true;
                    this.logoProgress = 0;
                    interval = setInterval(() => {
                        if (this.logoProgress < 99) {
                            this.logoProgress += 1;
                        }
                    }, 100);
                    timeout = setTimeout(() => {
                        if (this.logoProgress >= 99 && this.logoProgress < 100) {
                            this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
                            this.showLogoProgressBar = false;
                            clearInterval(interval);
                        }
                    }, 5000);
                    this.ngxLoaderService.start();
                    let requestObj = {
                        name: this.selectedCompanyLogoFile.name,
                        fileType: this.selectedCompanyLogoFile.type,
                        category: 'company'
                    };

                    this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
                        try {
                            if (res && res.success) {
                                const signedUrl = res.data.uploadURL;
                                const fileId = res.data.fileId;
                                if (signedUrl) {
                                    let headers: HttpHeaders = new HttpHeaders({
                                        "Content-Type": requestObj.fileType
                                    });

                                    this.fileHandlerService.UploadFile(signedUrl, this.selectedCompanyLogoFile, headers).subscribe((f) => {
                                        if (f === null) {
                                            // console.log('F', f);
                                            this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                                                if (res && res.success) {
                                                    this.ngxLoaderService.stop();
                                                    // console.log(res);
                                                    this.companyForm.get('companyLogoFileControl').setValue(fileId);
                                                    this.companyLogoFileName = res.data.name;
                                                    this.companyLogoFileURL = res.data.url;
                                                    this.logoProgress = 100;
                                                    clearInterval(interval);
                                                    clearTimeout(timeout);
                                                    setTimeout(() => {
                                                        this.showLogoProgressBar = false;
                                                    }, 1000);
                                                    this.ngxLoaderService.stop();
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        } catch (error) {
                            console.error(error);
                            this.ngxLoaderService.stop();
                        }
                    });
                } else {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Please select a file to upload', '', 'error');
                }

            } else if (selectedType === 'Signature') {
                if (this.selectedSignatureFile) {
                    this.showsignatrueProgressBar = true;
                    this.signatrueProgress = 0;
                    interval = setInterval(() => {
                        if (this.signatrueProgress < 99) {
                            this.signatrueProgress += 1;
                        }
                    }, 100);
                    timeout = setTimeout(() => {
                        if (this.signatrueProgress >= 99 && this.signatrueProgress < 100) {
                            this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
                            this.showsignatrueProgressBar = false;
                            clearInterval(interval);
                        }
                    }, 5000);
                    this.ngxLoaderService.start();
                    let requestObj = {
                        name: this.selectedSignatureFile.name,
                        fileType: this.selectedSignatureFile.type,
                        category: 'company'
                    };

                    this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
                        try {
                            if (res && res.success) {
                                const signedUrl = res.data.uploadURL;
                                const fileId = res.data.fileId;
                                if (signedUrl) {
                                    let headers: HttpHeaders = new HttpHeaders({
                                        "Content-Type": requestObj.fileType
                                    });
                                    this.fileHandlerService.UploadFile(signedUrl, this.selectedSignatureFile, headers).subscribe((f) => {
                                        if (f === null) {
                                            // console.log('F', f);
                                            this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                                                if (res && res.success) {
                                                    // console.log(res);
                                                    this.companyForm.get('signatureFileControl').setValue(fileId);
                                                    this.signatureFileName = res.data.name;
                                                    this.signatureFileURL = res.data.url;
                                                    this.signatrueProgress = 100;
                                                    clearInterval(interval);
                                                    clearTimeout(timeout);
                                                    setTimeout(() => {
                                                        this.showsignatrueProgressBar = false;
                                                    }, 1000);
                                                    this.ngxLoaderService.stop();
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        } catch (error) {
                            this.ngxLoaderService.stop();
                            console.error(error);
                        }
                    });
                } else {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Please select a file to upload', '', 'error');
                }
            }

        } catch (e) {
            this.ngxLoaderService.stop();
            console.error(e);
        }
    }

    updateCompany() {
        this.isFormSubmitted = true;
        if (this.permConfig.isEditAllowed && this.companyForm.valid) {
            let companyArea = this.companyForm.get('locationdetails').get('txtArea')?.value;
            companyArea = (typeof companyArea === 'string') ? companyArea : companyArea?.area;
            let compPincode = this.companyForm.get('locationdetails').get('txtPincode').value
            compPincode = (typeof compPincode === 'string') ? compPincode : compPincode?.pincode;

            const requestObj = {
                id: this.companyId,
                code: this.companyForm.get('txtCode')?.value,
                name: this.companyForm.get('txtName')?.value,
                emailid: this.companyForm.get('txtEmailId')?.value,
                operationtype: this.companyForm.get('ddlOperationType')?.value,
                servicecenters: this.companyForm.get('ddlServiceCenters')?.value,
                website: this.companyForm.get('txtWebsite')?.value,
                gstno: this.companyForm.get('txtGstNo')?.value,
                panno: this.companyForm.get('txtPanNo')?.value,
                registrationno: this.companyForm.get('txtRegistrationNo')?.value,
                billingname: this.companyForm.get('txtBillingName')?.value,
                billto: this.companyForm.get('ddlBillTo')?.value,
                invoiceformatid: this.companyForm.get('ddlInvoiceFormat')?.value,
                logoid: this.companyForm.get('companyLogoFileControl')?.value,
                signaturelogoid: this.companyForm.get('signatureFileControl')?.value,
                isactive: this.companyForm.get('txtStatus')?.value,
                isdefault: this.companyForm.get('chkIsDefault').value,
                location: {
                    country: this.companyForm.get('locationdetails').get('ddlCountry').value,
                    state: this.companyForm.get('locationdetails').get('ddlState').value,
                    city: this.companyForm.get('locationdetails').get('ddlCity').value,
                    area: companyArea,
                    pincode: compPincode,
                    address1: this.companyForm.get('locationdetails').get('txtAddress1').value,
                    address2: this.companyForm.get('locationdetails').get('txtAddress2').value,
                    mobileno: this.companyForm.get('locationdetails').get('txtMobileNo').value,
                    tel: this.companyForm.get('locationdetails').get('txtTelephoneNo').value
                },
                bankdetails: {
                    bankName: this.companyForm.get('bankDetails').get('txtBankName')?.value,
                    accountNo: this.companyForm.get('bankDetails').get('txtAccountNo')?.value,
                    accountName: this.companyForm.get('bankDetails').get('txtAccountName')?.value,
                    bankAddress: this.companyForm.get('bankDetails').get('txtBankAddress')?.value,
                    ifsc: this.companyForm.get('bankDetails').get('txtIfscCode')?.value,
                    micr: this.companyForm.get('bankDetails').get('txtMicr')?.value,
                },
                terms: this.companyForm.get('terms').get('txtTerms')?.value,

            }
            // console.log(requestObj);
            this.ngxLoaderService.start();
            this.companyService.Update(requestObj).subscribe((res) => {
                try {
                    if (res) {
                        if (!res.success && res?.data?.err_msg) {
                            this.ngxLoaderService.stop();
                            return this.appCoreService.showMessage(res?.data?.err_msg, 'Error', 'error');
                        }
                        if (!res.success) {
                            this.ngxLoaderService.stop();
                            this.openErrorDialog(res.message);
                        }
                        if (res.success) {
                            this.ngxLoaderService.stop();
                            // this.resetForm();
                            this.openMessageDialog('Record Updated Successfully');
                        }
                    }

                }
                catch (err) {
                    this.ngxLoaderService.stop();
                    console.error(err);
                }
            })
        }
    }

    resetForm(): void {
        this.companyForm.reset();
        this.isFormSubmitted = false;
        this.companyForm.get('ddlBillTo').setValue('Customer');
    }

    validateFileType(file: File) {
        const allowedTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg+xml'];
        if (allowedTypes.includes(file.type)) {
        } else {
            this.openCorrectFileType();
        }
    }

    openCorrectFileType() {
        this.openErrorDialog('File Formate only JPEG , JPG , PNG and SVG files are alloweds');
    }

    back() {
        const companyLogo = this.companyForm.get('txtCompanyLogo')?.value;
        const signatoryLogo = this.companyForm.get('txtSignatoryLogo')?.value;
        const allowedTypes = ['jpg', 'jpeg', 'png', 'svg'];
        // if(companyLogo!==null){
        //     const companyFileName = companyLogo.split('\\').pop();
        //     const companyType=companyFileName.split('.').pop().toLowerCase();
        //     if (companyLogo && !allowedTypes.includes(companyType)) {
        //         this.companyForm.get('txtCompanyLogo').setValue(null);
        //         this.companyLogoContent='';
        //     }
        // }
        // if(signatoryLogo!==null){
        //     const signatoryFileName = signatoryLogo.split('\\').pop();  
        //     const signatoryType=signatoryFileName.split('.').pop().toLowerCase();
        //     if (signatoryLogo && !allowedTypes.includes(signatoryType)) {
        //         this.companyForm.get('txtSignatoryLogo').setValue(null);
        //         this.signatoryLogoContent='';
        //     }
        // }
    }

    // downloadCompanyLogo(){
    //     if(this.companyLogoContent){
    //       const downloadLink=document.createElement('a');
    //       downloadLink.href=this.companyLogoContent;
    //       downloadLink.download=this.companyLogoFileName;
    //       downloadLink.click();
    //     }
    // }

    // downloadSignatoryLogo() {
    //     if (this.signatoryLogoContent) {
    //         const downloadLink = document.createElement('a');
    //         downloadLink.href = this.signatoryLogoContent;
    //         downloadLink.download = this.signatoryLogoFileName;
    //         downloadLink.click();
    //     }
    // }

    submitInvoiceForm() {
        if (this.invoiceForm.invalid) {
            return;
        }

        const reqObj = {
            id: this.invoiceId,
            companyrefid: this.companyId,
            // financialyear: this.invoiceForm.get('txtFinancialYear')?.value,
            producttype: this.invoiceForm.get('txtProductType')?.value,
            setuptype: this.invoiceForm.get('txtSetupType')?.value,
            prefix: this.invoiceForm.get('txtPrefix')?.value,
            suffix: this.invoiceForm.get('txtSuffix')?.value,
            lastinvoiceno: this.invoiceForm.get('txtLastInvoiceNo')?.value,
            invoiceformatid: this.invoiceForm.get('ddlInvoiceFormat')?.value
        }
        if (this.isEditInvoice) {
            // this.invoiceSerivce.Update(reqObj).subscribe((res)=>{
            //     if(res && res.success){
            //         this.resetInvoiceForm();
            //         this.reloadGrid();
            //         this.isEditInvoice=false;
            //     }
            // })
        }
        else {
            // this.invoiceSerivce.Add(reqObj).subscribe((res)=>{
            //     if(res && res.success){
            //         this.resetInvoiceForm();
            //         // this.reloadGrid();
            //     }
            // })
        }
    }

    resetInvoiceForm() {
        this.invoiceForm.reset();
        this.isFormSubmitted = false;
    }

    removeInvoiceEdit() {
        this.isEditInvoice = false
        this.invoiceForm.reset();
    }

    getInvoiceFormById(id: string) {
        // this.invoiceSerivce.GetById(id).subscribe((res)=>{                                                                                                                                                      
        //     if(res && res.success)
        //     {
        //         this.isEditInvoice=true;
        //         this.invoiceId=id;
        //         this.invoiceForm.get('txtFinancialYear').setValue(res.data[0].financialyear),
        //         this.invoiceForm.get('txtProductType').setValue(res.data[0].producttype),
        //         this.invoiceForm.get('txtSetupType').setValue(res.data[0].setuptype),
        //         this.invoiceForm.get('txtPrefix').setValue(res.data[0].prefix),
        //         this.invoiceForm.get('txtSuffix').setValue(res.data[0].suffix),
        //         this.invoiceForm.get('txtLastInvoiceNo').setValue(res.data[0].lastinvoiceno),
        //         this.invoiceForm.get('txtInvoiceFormat').setValue(res.data[0].invoiceformat)
        //     }
        // })
    }

    async openMessageDialog(msg: any) {
        const res = await Swal.fire({
            // title: 'Success',
            text: msg,
            icon: 'success',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
        if (res.isConfirmed) {
            this.router.navigate(['setup/companies'])
        }
    }

    async openErrorDialog(msg: any) {
        const result = await Swal.fire({
            title: 'Error',
            text: msg,
            icon: 'error',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
        if (result.isConfirmed) {
            this.back();
        }
    }

    GetAllInvoiceFormats() {
        try {
            this.miscService.GetAllInvoiceFormats().subscribe(res => {
                if (res?.success) {
                    this.invoiceFormatList = res.data;
                }
            })
        } catch (error) {
        }
    }

    blockFormSubmit() {
        return false;
    }

    redirectToNewWindow() {
        const websiteUrl = this.companyForm.get('txtWebsite')?.value;
        if (websiteUrl) {
            const hasProtocol = websiteUrl.startsWith('http://') || websiteUrl.startsWith('https://');
            const urlToOpen = hasProtocol ? websiteUrl : `http://${websiteUrl}`;
            window.open(urlToOpen, '_blank');
        }
    }

    formateDate(date?: any) {
        const inputDate = date != null ? new Date(date) : new Date();
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
        const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
        const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
        const dateString = `${year}-${month}-${day}`;
        const newFinancialYrDate = new Date(inputDate);
        newFinancialYrDate.setFullYear(newFinancialYrDate.getFullYear() + 1);
        const financialYr = newFinancialYrDate.toISOString().split('T')[0];

        return { dateString, dateTimeString, financialYr };
    }
}